function Testimonial({ quote, name, jobTitle, company, letterUrl }) {
  return (
    <figure className="pr-8 break-inside-avoid">
      <svg viewBox="0 0 28 22" fill="none" className="w-7">
        <path
          opacity=".15"
          d="M6.277 21.336c-1.296 0-2.4-.336-3.312-1.008-.912-.672-1.608-1.584-2.088-2.736-.48-1.152-.72-2.424-.72-3.816 0-1.824.336-3.552 1.008-5.184a14.814 14.814 0 0 1 2.88-4.464A14.493 14.493 0 0 1 8.653.816l3.6 3.024c-1.296.48-2.448 1.104-3.456 1.872a13.257 13.257 0 0 0-2.592 2.592c-.672.96-1.152 1.944-1.44 2.952l.288.216a2.55 2.55 0 0 1 .792-.432c.336-.096.792-.144 1.368-.144.672 0 1.344.192 2.016.576.72.336 1.32.864 1.8 1.584.48.72.72 1.656.72 2.808 0 1.056-.264 1.992-.792 2.808a5.391 5.391 0 0 1-1.944 1.944c-.816.48-1.728.72-2.736.72Zm14.76 0c-1.296 0-2.4-.336-3.312-1.008-.912-.672-1.608-1.584-2.088-2.736-.48-1.152-.72-2.424-.72-3.816 0-1.824.336-3.552 1.008-5.184a14.814 14.814 0 0 1 2.88-4.464A14.493 14.493 0 0 1 23.413.816l3.672 3.024a14.558 14.558 0 0 0-3.528 1.872 11.69 11.69 0 0 0-2.52 2.592 11.479 11.479 0 0 0-1.512 2.952l.288.216a2.55 2.55 0 0 1 .792-.432c.336-.096.792-.144 1.368-.144.672 0 1.344.192 2.016.576.72.336 1.32.864 1.8 1.584.48.72.72 1.656.72 2.808 0 1.056-.24 1.992-.72 2.808a5.237 5.237 0 0 1-2.016 1.944c-.816.48-1.728.72-2.736.72Z"
          fill="#005288"
        />
      </svg>

      <blockquote className="mt-4 text-sm italic lg:text-base xl:text-lg">
        <p>{quote}</p>
      </blockquote>

      <figcaption className="items-center mt-4 md:flex">
        <div className="text-sm lg:text-base">
          {name && (
            <div className="font-bold">
              {letterUrl ? (
                <a
                  href={letterUrl}
                  className="text-secondary-hover"
                  data-modal="letter"
                  data-modal-disable-default-close
                >
                  {name}
                </a>
              ) : (
                <span className="text-blue">{name}</span>
              )}
            </div>
          )}
          {jobTitle && <div>{jobTitle}</div>}
          {company && <div>{company}</div>}
        </div>
      </figcaption>
    </figure>
  )
}

export default Testimonial
